import { ItemKind } from '../../../constants/ItemKind';
import { MediaType } from '../../../constants/MediaType';
export function toFolder(data) {
  return {
    id: data.id,
    name: data.title,
    kind: ItemKind.Folder,
    source: 'googlePhotos',
    mediaType: MediaType.Picture,
    thumbnailUrl: data.coverPhotoBaseUrl,
    parentId: null,
    filesCount: parseInt(data.mediaItemsCount, 10),
    createdAt: null
  };
}